import { LayerData } from "./layerData.model";

export class TextLayerData extends LayerData {
  text: string;
  font: string;
  color: [number, number, number];
  font_size: number;
  horizontal_align: string;
  text_align: string;
  overflow: string;

  constructor(data?: Partial<TextLayerData>) {
    super(data);
    this.text = data?.text || "New Text";
    this.font = data?.font || "Inter-400";
    this.color = (data?.color as [number, number, number]) ?? [0, 0, 0];
    this.type = data?.type || "text";
    this.font_size = data?.font_size || 32;
    this.horizontal_align = data?.horizontal_align || "center";
    this.text_align = data?.text_align || "center";
    this.overflow = data?.overflow || "wrap";

    if (!data?.size_h && !data?.size_w) {
      this.size_h = 100;
      this.size_w = 300;
    }
  }

}


